const HR = {
  listedPublicCompany: [
    "listed dioničko društvo (d.d.)"
  ],
  nonProfit: [
    "non-profit udrgua"
  ],
  privateCompany: [
    "društvo s ograničenom odgovornošću (d.o.o.)",
    "jednostavno društvo s ograničenom odgovornošću (j.d.o.o.)",
    "unlisted dioničko društvo (d.d.)"
  ]
};
export {
  HR as default
};
